import { createContext } from 'react';

const CascadingMenuContext = createContext({
  parentPopupState: null,
  rootPopupState: null,
});

export default CascadingMenuContext;
